import type { JSX } from 'solid-js';
import { Popover } from './Popover';

// A short explanation anchored to the thing it explains (#6560): the Machines cards' CPU,
// Memory and Disk bars. Dashboard-only (`packages/ui` holds cross-app primitives only,
// `packages/ui/CLAUDE.md` § Boundary), and built on `<Popover/>` rather than beside it, so
// it inherits the one outside-click and Escape hygiene: Escape closes only the top-most
// layer on `lib/dialog-trap.ts`'s stack, and focus returns to the trigger.
//
// The trigger is a focusable button: a click, a tap, Enter or Space opens the sentence, and
// Escape or a click elsewhere closes it. It does not open on hover, which `<Popover/>`
// does not do; on a phone a tap is the only way in anyway.

export function Tooltip(props: {
  /** The trigger's accessible name: what it shows, said in words ("CPU 100%+"). */
  readonly label: string;
  /** What the trigger shows. */
  readonly trigger: JSX.Element;
  /** The sentence. */
  readonly text: string;
  /** Open the panel toward the left, for a trigger at the right edge of its card. */
  readonly alignEnd?: boolean;
}): JSX.Element {
  return (
    <Popover
      label={props.label}
      trigger={props.trigger}
      class="tooltip"
      triggerClass="tooltip__trigger"
      panelClass={props.alignEnd === true ? 'tooltip__panel tooltip__panel--end' : 'tooltip__panel'}
    >
      {() => <p class="tooltip__text">{props.text}</p>}
    </Popover>
  );
}
